<template>
  <d2-container>
    <template slot="header">
      <el-select
        v-model="listQuery.channelType"
        clearable
        placeholder="渠道类型"
        size="small"
        style="width: 140px; margin-right: 10px;"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="图片" value="image"></el-option>
        <el-option label="视频" value="video"></el-option>
      </el-select>
      <el-input
        v-model="listQuery.keyword"
        clearable
        size="small"
        placeholder="渠道ID/名称"
        style="width: 220px; margin-right: 10px;"
        @keyup.enter.native="handleChannelSearch"
      ></el-input>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="handleChannelSearch"
      >搜索</el-button>
      <el-button
        type="primary"
        plain
        size="small"
        icon="el-icon-document"
        @click="openTaskDialog"
      >查看任务列表</el-button>
      <el-button
        type="success"
        size="small"
        icon="el-icon-refresh"
        @click="refreshStatus"
      >刷新状态</el-button>
    </template>

    <div class="task-overview" v-loading="overviewLoading">
      <el-row :gutter="12">
        <el-col :span="4">
          <el-card shadow="hover" class="overview-card overview-card--total">
            <div class="overview-label">总任务</div>
            <div class="overview-value">{{ formatCount(taskOverview.totalCount) }}</div>
            <div class="overview-meta">今日 {{ formatCount(taskOverview.todayTotalCount) }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="overview-card overview-card--running">
            <div class="overview-label">进行中</div>
            <div class="overview-value">{{ formatCount(taskOverview.runningCount) }}</div>
            <div class="overview-meta">今日 {{ formatCount(taskOverview.todayRunningCount) }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="overview-card overview-card--success">
            <div class="overview-label">已成功</div>
            <div class="overview-value">{{ formatCount(taskOverview.succeededCount) }}</div>
            <div class="overview-meta">今日 {{ formatCount(taskOverview.todaySucceededCount) }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="overview-card overview-card--failed">
            <div class="overview-label">已失败</div>
            <div class="overview-value">{{ formatCount(taskOverview.failedCount) }}</div>
            <div class="overview-meta">今日 {{ formatCount(taskOverview.todayFailedCount) }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="overview-card overview-card--image">
            <div class="overview-label">图片任务</div>
            <div class="overview-value">{{ formatCount(taskOverview.imageCount) }}</div>
            <div class="overview-meta">今日 {{ formatCount(taskOverview.todayImageCount) }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="hover" class="overview-card overview-card--video">
            <div class="overview-label">视频任务</div>
            <div class="overview-value">{{ formatCount(taskOverview.videoCount) }}</div>
            <div class="overview-meta">今日 {{ formatCount(taskOverview.todayVideoCount) }}</div>
          </el-card>
        </el-col>
      </el-row>
      <div class="overview-summary">
        <span>累计平均完成耗时：{{ formatDuration(taskOverview.avgElapsedMs) }}</span>
        <span>今日平均完成耗时：{{ formatDuration(taskOverview.todayAvgElapsedMs) }}</span>
        <span>今日使用人数：{{ formatCount(taskOverview.todayUserCount) }}</span>
        <span>累计成功率：{{ overviewSuccessRate }}</span>
        <span>当前概览范围：{{ listQuery.channelType ? (listQuery.channelType === 'video' ? '视频渠道' : '图片渠道') : '全部渠道' }}</span>
      </div>
    </div>

    <el-table
      size="small"
      stripe
      border
      :data="list"
      v-loading="listLoading"
    >
      <el-table-column prop="channelId" label="渠道ID" width="140" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道名称" min-width="130"></el-table-column>
      <el-table-column prop="channelType" label="类型" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.channelType === 'video' ? 'warning' : 'success'">
            {{ scope.row.channelType === 'video' ? '视频' : '图片' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="代码可用" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.codeAvailable ? 'success' : 'danger'">
            {{ scope.row.codeAvailable ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="熔断状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="getCircuitTagType(scope.row.circuitState)">
            {{ scope.row.circuitState || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="总成功" prop="totalSuccess" width="90" align="center"></el-table-column>
      <el-table-column label="总失败" prop="totalFailure" width="90" align="center"></el-table-column>
      <el-table-column label="今日成功" prop="todaySuccess" width="90" align="center"></el-table-column>
      <el-table-column label="今日失败" prop="todayFailure" width="90" align="center"></el-table-column>
      <el-table-column label="成功率" width="90" align="center">
        <template slot-scope="scope">
          {{ formatSuccessRate(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="总平均耗时" width="100" align="center">
        <template slot-scope="scope">
          {{ formatDuration(scope.row.avgResponseTime) }}
        </template>
      </el-table-column>
      <el-table-column label="今日平均耗时" width="100" align="center">
        <template slot-scope="scope">
          {{ formatDuration(scope.row.todayAvgResponseTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="lastSuccessTime" label="最后成功" width="165" align="center"></el-table-column>
      <el-table-column prop="lastFailureTime" label="最后失败" width="165" align="center"></el-table-column>
      <el-table-column label="最后错误" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.lastError || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="任务列表"
      :visible.sync="taskDialogVisible"
      width="90%"
      top="5vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="task-toolbar">
        <el-select
          v-model="taskQuery.taskType"
          clearable
          size="small"
          placeholder="任务类型"
          style="width: 130px;"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="图片" value="image"></el-option>
          <el-option label="视频" value="video"></el-option>
        </el-select>
        <el-select
          v-model="taskQuery.status"
          clearable
          size="small"
          placeholder="任务状态"
          style="width: 140px;"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="进行中" value="running"></el-option>
          <el-option label="成功" value="succeeded"></el-option>
          <el-option label="失败" value="failed"></el-option>
        </el-select>
        <el-input
          v-model.trim="taskQuery.channelId"
          clearable
          size="small"
          placeholder="渠道ID"
          style="width: 150px;"
          @keyup.enter.native="handleTaskSearch"
        ></el-input>
        <el-input
          v-model.trim="taskQuery.merchantId"
          clearable
          size="small"
          placeholder="商家ID"
          style="width: 140px;"
          @keyup.enter.native="handleTaskSearch"
        ></el-input>
        <el-input
          v-model.trim="taskQuery.keyword"
          clearable
          size="small"
          placeholder="任务ID/渠道任务ID/模型"
          style="width: 260px;"
          @keyup.enter.native="handleTaskSearch"
        ></el-input>
        <el-date-picker
          v-model="taskDateRange"
          type="datetimerange"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="width: 340px;"
        ></el-date-picker>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="handleTaskSearch"
        >搜索</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh-left"
          @click="resetTaskSearch"
        >重置</el-button>
      </div>

      <el-table
        size="small"
        stripe
        border
        height="60vh"
        :data="taskList"
        v-loading="taskLoading"
      >
        <el-table-column label="类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.taskType === 'video' ? 'warning' : 'success'">
              {{ formatTaskType(scope.row.taskType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="任务ID" min-width="240" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="task-id-cell">
              <div>{{ scope.row.taskId || '-' }}</div>
              <div class="task-sub-id">渠道任务: {{ scope.row.channelTaskId || '-' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="渠道" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="task-id-cell">
              <div>{{ scope.row.channelId || '-' }}</div>
              <div class="task-sub-id">{{ scope.row.channelName || '-' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尝试渠道" min-width="220">
          <template slot-scope="scope">
            <div
              v-if="hasMedia(scope.row.triedChannelIds)"
              class="task-channel-tags"
            >
              <el-tag
                v-for="(channelId, index) in scope.row.triedChannelIds"
                :key="`${scope.row.taskId}-tried-${index}`"
                size="mini"
                :type="channelId === scope.row.channelId ? 'success' : 'info'"
                effect="plain"
              >
                {{ channelId }}
              </el-tag>
            </div>
            <div v-else class="task-empty">-</div>
          </template>
        </el-table-column>
        <el-table-column prop="merchantId" label="商家ID" width="110" align="center"></el-table-column>
        <el-table-column prop="modelName" label="模型" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="输入" min-width="320">
          <template slot-scope="scope">
            <div class="task-media-cell">
              <el-popover
                v-if="scope.row.prompt"
                placement="top-start"
                width="420"
                trigger="hover"
              >
                <div class="task-popover-text">{{ scope.row.prompt }}</div>
                <div slot="reference" class="task-text-ellipsis">
                  <span class="task-text-label">Prompt:</span>
                  <span>{{ scope.row.prompt }}</span>
                </div>
              </el-popover>
              <el-popover
                v-if="scope.row.negativePrompt"
                placement="top-start"
                width="420"
                trigger="hover"
              >
                <div class="task-popover-text">{{ scope.row.negativePrompt }}</div>
                <div slot="reference" class="task-text-ellipsis task-text-ellipsis--danger">
                  <span class="task-text-label">Negative:</span>
                  <span>{{ scope.row.negativePrompt }}</span>
                </div>
              </el-popover>
              <div
                v-if="hasMedia(scope.row.inputPreviewUrls)"
                class="task-media-list"
              >
                <el-image
                  v-for="(url, index) in sliceMedia(scope.row.inputPreviewUrls, 4)"
                  :key="`${scope.row.taskId}-input-${index}`"
                  :src="url"
                  :preview-src-list="scope.row.inputPreviewUrls"
                  fit="cover"
                  class="task-image-thumb"
                ></el-image>
                <span
                  v-if="scope.row.inputPreviewUrls.length > 4"
                  class="task-media-more"
                >+{{ scope.row.inputPreviewUrls.length - 4 }}</span>
              </div>
              <div
                v-if="!scope.row.prompt && !scope.row.negativePrompt && !hasMedia(scope.row.inputPreviewUrls)"
                class="task-empty"
              >-</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="结果" min-width="280">
          <template slot-scope="scope">
            <div class="task-media-cell">
              <div
                v-if="hasMedia(scope.row.resultImageUrls)"
                class="task-media-list"
              >
                <el-image
                  v-for="(url, index) in sliceMedia(scope.row.resultImageUrls, 4)"
                  :key="`${scope.row.taskId}-result-image-${index}`"
                  :src="url"
                  :preview-src-list="scope.row.resultImageUrls"
                  fit="cover"
                  class="task-image-thumb"
                ></el-image>
                <span
                  v-if="scope.row.resultImageUrls.length > 4"
                  class="task-media-more"
                >+{{ scope.row.resultImageUrls.length - 4 }}</span>
              </div>
              <div
                v-if="hasMedia(scope.row.resultVideoUrls)"
                class="task-video-list"
              >
                <div
                  v-for="(url, index) in sliceMedia(scope.row.resultVideoUrls, 2)"
                  :key="`${scope.row.taskId}-result-video-${index}`"
                  class="task-video-item"
                >
                  <video :src="url" class="task-video-thumb" controls preload="metadata"></video>
                  <el-link :href="url" target="_blank" type="primary" :underline="false">打开视频</el-link>
                </div>
              </div>
              <div
                v-if="!hasMedia(scope.row.resultImageUrls) && !hasMedia(scope.row.resultVideoUrls)"
                class="task-empty"
              >-</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="getTaskStatusTagType(scope.row.status)">
              {{ formatTaskStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="progress" label="进度" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.row.progress != null ? `${scope.row.progress}%` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="retryCount" label="重试" width="70" align="center"></el-table-column>
        <el-table-column label="耗时" width="100" align="center">
          <template slot-scope="scope">
            {{ formatDuration(scope.row.elapsedMs) }}
          </template>
        </el-table-column>
        <el-table-column prop="startedAt" label="开始时间" width="170" align="center">
          <template slot-scope="scope">
            {{ scope.row.startedAt || scope.row.createTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="completedAt" label="完成时间" width="170" align="center">
          <template slot-scope="scope">
            {{ scope.row.completedAt || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="错误信息" min-width="240" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.error || scope.row.failureReason || '-' }}
          </template>
        </el-table-column>
      </el-table>

      <div class="task-pagination">
        <el-pagination
          @size-change="handleTaskSizeChange"
          @current-change="handleTaskCurrentChange"
          :current-page.sync="taskQuery.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="taskQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="taskTotal"
        ></el-pagination>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  getChannelStatusList,
  getChannelTaskOverview,
  getChannelTaskPage,
  refreshChannelStatusCache
} from '@/api/merchant/service/channel'

export default {
  name: 'serviceChannelStatus',
  data () {
    return {
      list: [],
      taskList: [],
      taskTotal: 0,
      listLoading: false,
      overviewLoading: false,
      taskLoading: false,
      taskDialogVisible: false,
      taskDateRange: [],
      listQuery: {
        channelType: '',
        keyword: ''
      },
      taskOverview: {
        totalCount: 0,
        runningCount: 0,
        succeededCount: 0,
        failedCount: 0,
        imageCount: 0,
        videoCount: 0,
        avgElapsedMs: 0,
        todayTotalCount: 0,
        todayRunningCount: 0,
        todaySucceededCount: 0,
        todayFailedCount: 0,
        todayImageCount: 0,
        todayVideoCount: 0,
        todayUserCount: 0,
        todayAvgElapsedMs: 0
      },
      taskQuery: {
        currentPage: 1,
        pageSize: 10,
        taskType: '',
        channelId: '',
        status: '',
        merchantId: '',
        keyword: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  computed: {
    overviewSuccessRate () {
      const success = Number(this.taskOverview.succeededCount || 0)
      const failure = Number(this.taskOverview.failedCount || 0)
      const total = success + failure
      if (total <= 0) {
        return '-'
      }
      return `${((success / total) * 100).toFixed(1)}%`
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    initPage () {
      this.handleChannelSearch()
    },
    normalizeList (res) {
      let records = []
      if (Array.isArray(res)) {
        records = res
      } else if (res && Array.isArray(res.records)) {
        records = res.records
      } else if (res && Array.isArray(res.list)) {
        records = res.list
      }
      return records
    },
    normalizePage (res) {
      if (!res) {
        return { records: [], total: 0 }
      }
      return {
        records: Array.isArray(res.records) ? res.records : [],
        total: Number(res.total || 0)
      }
    },
    normalizeOverview (res) {
      return Object.assign({
        totalCount: 0,
        runningCount: 0,
        succeededCount: 0,
        failedCount: 0,
        imageCount: 0,
        videoCount: 0,
        avgElapsedMs: 0,
        todayTotalCount: 0,
        todayRunningCount: 0,
        todaySucceededCount: 0,
        todayFailedCount: 0,
        todayImageCount: 0,
        todayVideoCount: 0,
        todayUserCount: 0,
        todayAvgElapsedMs: 0
      }, res || {})
    },
    getSearch () {
      this.listLoading = true
      return getChannelStatusList({
        channelType: this.listQuery.channelType,
        keyword: this.listQuery.keyword
      }).then(res => {
        this.list = this.normalizeList(res)
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleChannelSearch () {
      this.getSearch()
      this.loadTaskOverview()
    },
    loadTaskOverview () {
      this.overviewLoading = true
      return getChannelTaskOverview({
        taskType: this.listQuery.channelType
      }).then(res => {
        this.taskOverview = this.normalizeOverview(res)
      }).finally(() => {
        this.overviewLoading = false
      })
    },
    getCircuitTagType (state) {
      if (state === 'OPEN') {
        return 'danger'
      }
      if (state === 'HALF_OPEN') {
        return 'warning'
      }
      return 'success'
    },
    formatSuccessRate (row) {
      const success = Number(row.totalSuccess || 0)
      const failure = Number(row.totalFailure || 0)
      const total = success + failure
      if (total <= 0) {
        return '-'
      }
      return `${((success / total) * 100).toFixed(1)}%`
    },
    formatDuration (ms) {
      const n = Number(ms || 0)
      if (!n) {
        return '-'
      }
      if (n < 1000) {
        return `${n}ms`
      }
      return `${(n / 1000).toFixed(2)}s`
    },
    formatCount (value) {
      return Number(value || 0)
    },
    hasMedia (list) {
      return Array.isArray(list) && list.length > 0
    },
    sliceMedia (list, limit) {
      if (!Array.isArray(list)) {
        return []
      }
      return list.slice(0, limit)
    },
    formatTaskType (type) {
      return type === 'video' ? '视频' : '图片'
    },
    formatTaskStatus (status) {
      if (status === 'succeeded') {
        return '成功'
      }
      if (status === 'failed') {
        return '失败'
      }
      return '进行中'
    },
    getTaskStatusTagType (status) {
      if (status === 'succeeded') {
        return 'success'
      }
      if (status === 'failed') {
        return 'danger'
      }
      return 'warning'
    },
    syncTaskDateRange () {
      if (Array.isArray(this.taskDateRange) && this.taskDateRange.length === 2) {
        this.taskQuery.startTime = this.taskDateRange[0]
        this.taskQuery.endTime = this.taskDateRange[1]
      } else {
        this.taskQuery.startTime = ''
        this.taskQuery.endTime = ''
      }
    },
    openTaskDialog () {
      if (!this.taskQuery.taskType && this.listQuery.channelType) {
        this.taskQuery.taskType = this.listQuery.channelType
      }
      this.taskDialogVisible = true
      this.handleTaskSearch()
    },
    handleTaskSearch (resetPage = true) {
      if (resetPage) {
        this.taskQuery.currentPage = 1
      }
      this.syncTaskDateRange()
      this.taskLoading = true
      return getChannelTaskPage(Object.assign({}, this.taskQuery)).then(res => {
        const page = this.normalizePage(res)
        this.taskList = page.records
        this.taskTotal = page.total
      }).finally(() => {
        this.taskLoading = false
      })
    },
    resetTaskSearch () {
      this.taskDateRange = []
      this.taskQuery = {
        currentPage: 1,
        pageSize: 10,
        taskType: this.listQuery.channelType || '',
        channelId: '',
        status: '',
        merchantId: '',
        keyword: '',
        startTime: '',
        endTime: ''
      }
      this.handleTaskSearch(false)
    },
    handleTaskSizeChange (val) {
      this.taskQuery.pageSize = val
      this.handleTaskSearch()
    },
    handleTaskCurrentChange (val) {
      this.taskQuery.currentPage = val
      this.handleTaskSearch(false)
    },
    refreshStatus () {
      refreshChannelStatusCache().then(() => {
        this.$message.success('渠道状态已刷新')
        this.handleChannelSearch()
        if (this.taskDialogVisible) {
          this.handleTaskSearch(false)
        }
      })
    }
  }
}
</script>

<style scoped>
.task-overview {
  margin-bottom: 16px;
}

.overview-card {
  border-radius: 10px;
  overflow: hidden;
}

.overview-card /deep/ .el-card__body {
  padding: 16px 18px;
}

.overview-card--total {
  border-top: 3px solid #266dd3;
}

.overview-card--running {
  border-top: 3px solid #e6a23c;
}

.overview-card--success {
  border-top: 3px solid #3a8f5c;
}

.overview-card--failed {
  border-top: 3px solid #d84b4b;
}

.overview-card--image {
  border-top: 3px solid #0f9d8a;
}

.overview-card--video {
  border-top: 3px solid #8c6ad9;
}

.overview-label {
  color: #6b7280;
  font-size: 12px;
  margin-bottom: 8px;
}

.overview-value {
  color: #111827;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.overview-meta {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}

.overview-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  margin-top: 10px;
  padding: 0 4px;
  color: #606266;
  font-size: 13px;
}

.task-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.task-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.task-id-cell {
  line-height: 1.35;
}

.task-sub-id {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
}

.task-media-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.task-text-ellipsis {
  display: block;
  color: #303133;
  font-size: 12px;
  line-height: 1.5;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.task-text-ellipsis--danger {
  color: #b45309;
}

.task-text-label {
  color: #909399;
  margin-right: 4px;
}

.task-popover-text {
  max-height: 220px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
}

.task-media-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.task-channel-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.task-image-thumb {
  width: 54px;
  height: 54px;
  border-radius: 8px;
  overflow: hidden;
  flex: 0 0 auto;
}

.task-media-more {
  color: #909399;
  font-size: 12px;
}

.task-video-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.task-video-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.task-video-thumb {
  width: 180px;
  height: 102px;
  border-radius: 8px;
  background: #000;
}

.task-empty {
  color: #c0c4cc;
  font-size: 12px;
}
</style>
